export const socials = [

    // -----------------------------
    // Feature Boxes
    // -----------------------------

    {
        key: "twitch",
        label: "Twitch",
        handle: "twitch.tv/doriantelive",
        url: "https://www.twitch.tv/doriantelive",
        category: "live gaming",
        accent: "red",
        span: "single",
        display: "box",
        internal: false,
        cta: "Watch Live Gaming",
        description:
            "Live gameplay — raw, unscripted, all skill and chaos. Come hang out on stream.",
    },


    {
        key: "tiktok",
        label: "TikTok",
        handle: "@doriantelive",
        url: "https://www.tiktok.com/@doriantelive",
        category: "clips & lives",
        accent: "green",
        span: "single",
        display: "box",
        internal: false,
        cta: "Watch the Clips",
        description:
            "Epic and funny moments, highlights and live drops. The best bits in bite size.",
    },


    {
        key: "comik_releaf",
        label: "Comik Re-Leaf",
        handle: "T-Shirt Brand",
        url: "/comik-releaf",
        category: "revival incoming",
        accent: "orange",
        span: "single",
        display: "box",
        internal: true,
        cta: "Preview Designs",
        description:
            "A funny tee brand. Old project revival right around the corner — designs still viewable.",
    },


    {
        key: "rugged_roofing",
        label: "Rugged Roofing",
        handle: "The Origin",
        url: "https://www.facebook.com/RuggedRoofing/",
        category: "where I came from",
        accent: "orange",
        span: "single",
        display: "box",
        internal: false,
        cta: "The Origin Story",
        description:
            "My old life before the reset — where the work ethic and grit were forged.",
    },


    // -----------------------------
    // Logo Quick Links
    // -----------------------------

    {
        key: "youtube",
        label: "YouTube",
        handle: "@Doriantelive",
        url: "https://www.youtube.com/@Doriantelive",
        category: "social",
        accent: "red",
        span: "single",
        display: "logo",
        internal: false,
    },


    {
        key: "discord",
        label: "Discord",
        handle: "Open World OG's",
        url: "https://discord.gg/K9xAbqjK",
        category: "social",
        accent: "green",
        span: "single",
        display: "logo",
        internal: false,
    },


    {
        key: "facebook_page",
        label: "Facebook Page",
        handle: "Doriantelive",
        url:
            "https://www.facebook.com/profile.php?id=61588750626806",
        category: "social",
        accent: "orange",
        span: "single",
        display: "logo",
        internal: false,
    },


    {
        key: "facebook_personal",
        label: "Personal Facebook",
        handle: "ryan.roadshow",
        url:
            "https://www.facebook.com/ryan.roadshow/",
        category: "social",
        accent: "orange",
        span: "single",
        display: "logo",
        internal: false,
    },

];